export function download (filename, text) {
  var pom = document.createElement('a')
  pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
  pom.setAttribute('download', filename)

  if (document.createEvent) {
    var event = document.createEvent('MouseEvents')
    event.initEvent('click', true, true)
    pom.dispatchEvent(event)
  } else {
    pom.click()
  }
}

export default {
  install (Vue, options) {
    Vue.mixin({ beforeCreate () {
      this.$download = download
    }})
  }
}



// WEBPACK FOOTER //
// ./src/extensions/download.js